import React from 'react'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'

import store from '../src/state/store'
import userManager from '../src/utils/oidc/user-manager'
import WrapWithDdAuthProtector from './wrap-with-dd-auth-protector'

const WrapWithProvider: React.FC<{ element: React.ComponentType }> = ({ element }) => (
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <WrapWithDdAuthProtector>{element}</WrapWithDdAuthProtector>
    </OidcProvider>
  </Provider>
)

export default WrapWithProvider
